import _ from 'lodash';
import { defineMessage } from 'react-intl';

import { fieldValues } from './linkBankAccountFormValidationHandler';

const requiredFieldMessage = defineMessage({
    id: '_.link_bank_account.required_field',
    defaultMessage: 'Required field'
});

// eslint-disable-next-line import/no-default-export
export default (values: fieldValues) => {
    let errors = {};

    if (!values.sortCode || values.sortCode.length !== 8) {
        errors = _.setWith(errors, 'sortCode', requiredFieldMessage);
    }

    if (!values.accountNumber || values.accountNumber.length !== 8) {
        errors = _.setWith(errors, 'accountNumber', requiredFieldMessage);
    }

    return errors;
};
